import React, { useEffect, useState } from 'react';
import Slider from '@mui/material/Slider';
import TextField from '@mui/material/TextField';
import './PriceRangeFilter.css';
import { FilterComponentProps } from '../filtersConfig';

const MIN = 5000;
const MAX = 30000;

const PriceRangeFilter: React.FC<FilterComponentProps> = ({ filters, onChange }) => {
  const [localRange, setLocalRange] = useState<[number, number]>([
    filters.minPricePerHour ?? MIN,
    filters.maxPricePerHour ?? MAX
  ]);

  useEffect(() => {
    if (filters.minPricePerHour !== undefined && filters.maxPricePerHour !== undefined) {
      setLocalRange([filters.minPricePerHour, filters.maxPricePerHour]);
    }
  }, [filters]);

  const handleSliderChange = (_: any, newValue: number | number[]) => {
    const [min, max] = newValue as [number, number];

    setLocalRange([min, max]);
    onChange({
      minPricePerHour: min,
      maxPricePerHour: max
    });
  };

  return (
    <div className="priceRangeContainer">
      <Slider
        min={MIN}
        max={MAX}
        step={500}
        value={localRange}
        onChange={handleSliderChange}
        valueLabelDisplay="auto"
      />

      <div className="priceInputs">
        <TextField
          label="Desde ($)"
          type="number"
          size="small"
          value={localRange[0]}
          onChange={(e) => setLocalRange([Number(e.target.value), localRange[1]])}
        />
        <TextField
          label="Hasta ($)"
          type="number"
          size="small"
          value={localRange[1]}
          onChange={(e) => setLocalRange([localRange[0], Number(e.target.value)])}
        />
      </div>
    </div>
  );
};

export default PriceRangeFilter;
